module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.53e0f6b5.svg";